export class RetrievalJwtTokenModel {
    public guid?: string;
    public message?: string;
    public token?: string;
    public profileImageUrl?: string;
}
  
